var App = App || {};

App.Video = (function ($) {
    'use strict';

    function init() {

        $(".component-video").each(function () {

            var Target = $(this).find(".component-video-placeholder");
            var Button = Target.find(".component-video-button");
            var Source = Button.attr("data-src");
            var Title = Button.attr("data-title");

            Button.click(function () {

                var source = Source.toLowerCase();

                switch (true) {
                    case source.indexOf("youtube") >= 0:
                        Youtube(Target, Source, Title);
                        break;
                    case source.indexOf("vimeo") >= 0:
                        Vimeo(Target, Source, Title);
                        break;
                    default:
                        console.log("Could not locate video content");
                }

            });
        });
    }

    function Youtube(Target, Source, Title) {
        var Template = "<iframe src=\"" + Source + "\" title=\"" + Title + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>";
        Target.html(Template);
    }

    function Vimeo(Target, Source, Title) {
        var Template = "<iframe src=\"" + Source + "\" title=\"" + Title + "\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen></iframe>";
        Target.html(Template);
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Video.init();
});